angular.module('unica_campaign_template.campaign_template_controllers', [])

.controller('CampaignTemplateBasicController',
	function(
		$rootScope, $scope, $stateParams, $filter, $timeout,
		$uibModal, $confirm,
		CampaignTemplateListService, CampaignTemplatePreviewService, CampaignTemplateEditService,
		CampaignAttachmentListService, CampaignAttachmentDeleteService, InvitationListService
	) {

	$scope.forms = {};
	$scope.invitations = [];

	InvitationListService
		.simpleList($stateParams.event_id)
		.then(function(data) {
			if ( data.length > 0 ) $scope.invitations = data;
		});

	$scope.resetCampaignTemplateData = function()
	{
		$scope.campaignTemplateData = {
			event_id: $stateParams.event_id,

			logo: {
				dataURL: '',
				resized: {
					dataURL: ''
				}
			},

			cover: {
				dataURL: '',
				resized: {
					dataURL: ''
				}
			},

			include_stage_data: true,
			include_hotel_data: false,
			include_transfer_data: false,
			include_credentials: false,
			include_go_to_site: false,
			include_go_to_workshop: false,
			include_registration_data: false,
			include_calendar_buttons: false,
			include_qr_code: false,
		};
	};


	$scope.getCampaignTemplate = function(campaignTemplateId)
	{
		$scope.showLoader();

		CampaignTemplateListService
			.get(campaignTemplateId)
			.then(function(data) {
				$scope.hideLoader();

				data.cover = {
					dataURL: data.cover,
					resized: {
						dataURL: data.cover
					}
				};

				data.logo = {
					dataURL: data.logo,
					resized: {
						dataURL: data.logo
					}
				};

				data.image = data.image ? {
					dataURL: data.image,
					resized: {
						dataURL: data.image
					}
				} : null;

				$scope.campaignTemplateData = data;

				$scope.loadCampaignAttachments();

				$scope.$broadcast('campaign_template_loaded');
			});
	};



	/**
	 * FUNCTIONS FOR UPLOAD ATTACHMENTS AND IMAGES
	 */

	$scope.changeCampaignTemplateLogo = function()
	{
		$rootScope.showLoader();
		$scope.campaignTemplateData.logo_changed = true;
	};

	$scope.$watch('campaignTemplateData.logo', function() {
		$rootScope.hideLoader();
	});


	$scope.changeCampaignTemplateCover = function()
	{
		$rootScope.showLoader();
		$scope.campaignTemplateData.cover_changed = true;
	};

	$scope.$watch('campaignTemplateData.cover', function()
	{
		$rootScope.hideLoader();
	});


	$scope.changeCampaignTemplateImage = function()
	{
		// console.log('test');
		$rootScope.showLoader();
		$scope.campaignTemplateData.image_changed = true;
	};

	$scope.$watch('campaignTemplateData.image', function()
	{
		$rootScope.hideLoader();
	});

	$scope.campaignAttachmentList = [];
	$scope.loadCampaignAttachments = function()
	{
		$scope.showLoader();

		CampaignAttachmentListService
			.list( $scope.campaignTemplateData.id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.campaignAttachmentList = data;
				}
			});
	};

	$scope.openAttachmentsModal = function ()
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy:  'modal-title',
			ariaDescribedBy: 'modal-body',
			controller:      'ModalAttachmentsInstanceController',
			controllerAs:    '$ctrl',
			templateUrl:     './templates/modals/attachments.html',
			size:            'lg',
			windowClass:     'modal-material'
		});

		modalInstance.result.then(function (data) {
			$scope.loadCampaignAttachments();
		}, function () { });
	};

	$scope.removeCampaignAttachment = function( attachmentId )
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'allegato?',
			text: 'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();
			CampaignAttachmentDeleteService
				.delete( attachmentId  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						angular.forEach($scope.campaignAttachmentList, function(attach, key) {
							if ( attach.id === attachmentId ) {
								$scope.campaignAttachmentList.splice(key, 1);
							}
						});

						$scope.showSuccessMsg('Allegato eliminato con successo!', '');
					}
				});

		}, function() { });
	};





	/**
	 * FUNCTIONS FOR AUTOCOMPLETE USER FOR PREVIEW
	 */

	$scope.searchText = '';
	$scope.searchTextInv = '';
	$scope.searchTextDest = '';

	$scope.searchServiceUser = function(query)
	{
		return query ? $filter('filter')($rootScope.servicesUsers, {label: query}) : $rootScope.servicesUsers;
	};
	$scope.searchServiceUserDest = function(query)
	{
		return query ? $filter('filter')($rootScope.servicesUsers, {label: query}) : $rootScope.servicesUsers;
	};
	$scope.searchServiceUserInv = function(query)
	{
		return query ? $filter('filter')($scope.invitations, {label: query}) : [];
	};

	$scope.selectedServiceUser = function(service)
	{
		if ( service ) {
			$scope.previewCampaignTemplateData.user_id = service.id;
		} else {
			$scope.previewCampaignTemplateData.user_id = null;
		}
	};

	$scope.selectedServiceUserInv = function(service)
	{
		if ( service ) {
			$scope.previewSimulateCampaignTemplateData.inv_id = service.id;
		} else {
			$scope.previewSimulateCampaignTemplateData.inv_id = null;
		}
	};

	$scope.selectedServiceUserDest = function(service)
	{
		if ( service ) {
			$scope.previewSimulateCampaignTemplateData.dest_id = service.id;
		} else {
			$scope.previewSimulateCampaignTemplateData.dest_id = null;
		}
	};



	/**
	 * FUNCTIONS FOR PREVIEW FUNCTIONALITY
	 */
	$scope.previewCampaignTemplateData = {
		user_id: null
	};
	$scope.previewSimulateCampaignTemplateData = {
		inv_id: null,
		dest_id: null
	};

	$scope.checkPreviewCampaignTemplateForm = function()
	{
		return ( !$scope.previewCampaignTemplateData.user_id ? true : false );
	};

	$scope.checkPreviewSimulateCampaignTemplateForm = function()
	{
		return ( (!$scope.previewSimulateCampaignTemplateData.inv_id || !$scope.previewSimulateCampaignTemplateData.dest_id) ? true : false );
	};

	$scope.previewCampaignTemplate = function()
	{
		$rootScope.showLoader();

		CampaignTemplatePreviewService
			.preview( $scope.campaignTemplateData.id, $scope.previewCampaignTemplateData.user_id )
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Anteprima inviata con successo!', '');
				}
			});
	};

	$scope.previewSimulateCampaignTemplate = function()
	{
		$rootScope.showLoader();

		CampaignTemplatePreviewService
			.previewSimulate( $scope.campaignTemplateData.id, $scope.previewSimulateCampaignTemplateData.inv_id, $scope.previewSimulateCampaignTemplateData.dest_id )
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Simulazione inviata con successo!', '');
				}
			});

	};



	/**
	 * FUNCTIONS FOR REMOVE IMAGES
	 */

	$scope.removeCampaignTemplateCover = function( )
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'immagine di copertina del template?',
			text:  'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			CampaignTemplateEditService
				.deleteCover( $scope.campaignTemplateData.id )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						$timeout(function() {
							$scope.campaignTemplateData.cover = {
								dataURL: '',
								resized: {
									dataURL: ''
								}
							};

							$scope.campaignTemplateData.cover_changed = false;
						}, 300);

						$scope.showSuccessMsg('Immagine Template Campagna eliminata con successo!', '');
					}
				});

		}, function() { });
	};

	$scope.removeCampaignTemplateLogo = function( )
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare il logo del template?',
			text:  'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			CampaignTemplateEditService
				.deleteLogo( $scope.campaignTemplateData.id )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						$timeout(function() {
							$scope.campaignTemplateData.logo = {
								dataURL: '',
								resized: {
									dataURL: ''
								}
							};

							$scope.campaignTemplateData.logo_changed = false;
						}, 300);

						$scope.showSuccessMsg('Logo Template Campagna eliminato con successo!', '');

					}
				});

		}, function() { });
	};


	$scope.removeCampaignTemplateImage = function( )
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare l\'immagine?',
			text:  'Confermi la cancellazione?'
		}).then(function() {

			$scope.showLoader();

			CampaignTemplateEditService
				.deleteImage( $scope.campaignTemplateData.id )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {

						$timeout(function() {
							$scope.campaignTemplateData.image = {
								dataURL: '',
								resized: {
									dataURL: ''
								}
							};

							$scope.campaignTemplateData.image_changed = false;
						}, 300);

						$scope.showSuccessMsg('Immagine Template Campagna eliminato con successo!', '');

					}
				});

		}, function() { });
	};

})


.controller('ModalAttachmentsInstanceController',
	function (
		$scope, $stateParams,
		$uibModalInstance, FileUploader, getBaseApiURL, Session
	) {

	$scope.attachmentsData = {
		files: []
	};

	$scope.uploadDone = false;

	$scope.uploader = new FileUploader({
		alias: 'files',
		url: getBaseApiURL + '/campaign-attachment/upload/' + $stateParams.id,
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$scope.uploader.onCompleteAll = function() {
		$scope.uploadDone = true;
	};

	$scope.uploadAttachments = function () {
		$scope.uploader.uploadAll();
	};

	$scope.closeModal = function() {
		if ( $scope.uploadDone ) {
			$uibModalInstance.close();
		} else {
			$uibModalInstance.dismiss('cancel');
		}
	};

	$scope.triggerInput = function() {
		setTimeout(function() {
			document.getElementById('files').click()
		}, 0);
	};

});